export default function FayettevilleARTravelTimingSection() {
  return (
    <section id="timing" className="py-16 md:py-24 bg-[#F7F8FA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Travel Timing</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">When Fayetteville, AR Travelers Need Passports</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            { month: "August–September", title: "Fall Study Abroad Peak", desc: "UA students departing for semester abroad programs. Rush orders spike at the start of the fall semester." },
            { month: "January–February", title: "Spring Study Abroad", desc: "Second wave of UA study abroad departures. Spring break planning also begins." },
            { month: "March–April", title: "Spring Break Rush", desc: "Cancun, Jamaica, and Caribbean destinations peak. NWA families book beach trips." },
            { month: "May–June", title: "Corporate Travel Season", desc: "Walmart global supplier meetings and summer corporate travel surge." },
            { month: "July–August", title: "Summer Travel Peak", desc: "Highest international travel volume. European family trips and adventure travel." },
            { month: "November–December", title: "Holiday Travel", desc: "Winter cruise bookings and holiday international travel. Renewal rush before year-end." },
          ].map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <p className="text-[#F6C344] text-xs font-bold uppercase tracking-wider mb-2">{t.month}</p>
              <h3 className="font-bold text-[#1A365D] text-lg mb-2">{t.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{t.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}